/**
 * QuestionInput Component
 *
 * Analysis question textarea with Tailwind styling.
 * Mode: Deep Analysis (Mode 3)
 */
import React from 'react';

export const QuestionInput = ({ question, setQuestion }) => {
  return (
    <div>
      <h3 className="text-lg font-medium text-zinc-100 mb-2">2. Ask a specific question</h3>
      <textarea
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        placeholder="E.g., How can I improve my form? What am I doing wrong with my technique?"
        className="w-full h-32 bg-[#0b1118] border border-white/10 text-zinc-200 placeholder-zinc-600 rounded-xl px-4 py-3 text-sm resize-none focus:outline-none focus:ring-1 focus:ring-orange-400/50"
      />
    </div>
  );
};
